import React from 'react';
import { Check } from 'lucide-react';

interface RangeSelectionControlsProps {
    onCancel: () => void;
    onConfirm: () => void;
    isConfirmDisabled: boolean;
    cancelLabel: string;
    confirmLabel: string;
}

const RangeSelectionControls: React.FC<RangeSelectionControlsProps> = ({
    onCancel,
    onConfirm,
    isConfirmDisabled,
    cancelLabel,
    confirmLabel
}) => {
    return (
        <div className="mt-4 flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700">
            <button
                onClick={onCancel}
                className="text-sm text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none rounded px-3 py-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-150"
            >
                {cancelLabel}
            </button>

            <button
                onClick={onConfirm}
                disabled={isConfirmDisabled}
                className="flex items-center text-sm text-white bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 dark:focus:ring-blue-400 dark:focus:ring-opacity-50 rounded px-3 py-1.5 transition-colors duration-150"
            >
                <Check className="h-4 w-4 mr-1" />
                {confirmLabel}
            </button>
        </div>
    );
};

export default React.memo(RangeSelectionControls);